import { useEffect, useState, useCallback, Dispatch } from 'react';
import { useSessionStorage, useTitle } from 'react-use';
import { useLocation } from 'react-router';
import { connect, useDispatch } from 'react-redux';

import { IUserInfo } from 'APIPackage/AuthModule/interfaces/IUserInfo';
import { CODE, STATE } from 'CorePackage/MainModule/constants/auth';
import { IS_ESIA } from 'CorePackage/MainModule/constants/localStorageNames';
import { Layout } from 'CorePackage/MainModule/components/Layout';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { UserLogin } from './UserLogin';
import styles from './AuthPage.module.scss';
import { getUserInfo } from '../selectors/authSelectors';
import { authLogout } from '../actions/authActions';

interface IAuthPageProps {
  user?: IUserInfo;
}

const AuthPageWithoutStore = ({ user }: IAuthPageProps) => {
  useTitle('Вход в систему — ФГИС Единый реестр проверок');

  const location = useLocation();
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [isContentCentered, setContentCentered] = useState(true);
  const [isEsia, setIsEsia] = useSessionStorage<boolean>(IS_ESIA);

  const handleClick = useCallback(async () => {
    dispatch(authLogout());
    // FIXME релоад страницы при логауте через ЕСИА вызываться не должен
    if (!isEsia) {
      window.location.reload();
    }
  }, [isEsia, dispatch]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (!!searchParams.get(STATE) && !!searchParams.get(CODE)) {
      setIsEsia(true);
      setContentCentered(false);
    }
  }, [location, setIsEsia]);

  return (
    <Layout withFooter showMenu={false} contentCentered={isContentCentered}>
      {user ? (
        <div className={styles.Wrapper}>
          <p>Вход уже выполнен.</p>
          <button className={styles.Link} type="button" id="logoutButton" onClick={handleClick}>
            Выйти из системы
          </button>
        </div>
      ) : (
        <UserLogin />
      )}
    </Layout>
  );
};

const mapStateToProps = (state: IRootState) => ({ user: getUserInfo(state) });

export const AuthPage = connect(mapStateToProps)(AuthPageWithoutStore);
